<template>
  <div>
    <vue-headful title="Matches" />
    <Header page_title="Matches" />
    <div v-if="results ? results.data && results.data.length > 0:false">
      <div class="px-4 mx-2">
        <div class="container-fluid px-0 pb-1 mb-2">
          <p class="mb-3">
            <strong>{{ results.data.length }} Match(es)</strong>
          </p>
          <div class="mb-5">
            <JobCard
              v-for="job in results.data"
              :key="job.id"
              :job="job"
              :job_ids="job_ids"
              recommended="true"
            />
            <Pagination :results="results" :api="api" @page-change="pageChanged" />
          </div>
        </div>
      </div>
    </div>
    <Empty v-else text="You don't have any recommended jobs." />
    <Footer />
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";

export default {
  data: function() {
    return {
      api: "jobs/recommended",
      recommended: null,
      job_ids: null
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      // this.recommended = await this.getTokenAPIList("jobs/recommended");
      this.results = await this.getListwithPages("jobs/recommended");
      if (this.results.data.length > 1) {
        this.job_ids = this.results.data.map(({ job_id }) => job_id);
      }
      this.$store.state.loading = false;
    },
    async pageChanged(data) {
      this.results = await this.getListwithPages(data);
    }
  },
  components: {
    JobCard
  }
};
</script>

<style scoped>
::v-deep .component .icon-wrapper + .details {
  width: calc(100% - 50px);
}
::v-deep .text.location {
  max-width: 100%;
}
</style>
